var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fee-input",class:{ inline: _vm.inline }},[_c('el-input',{attrs:{"size":"mini","placeholder":"请输入","value":_vm.value},on:{"input":_vm.input}}),_c('div',{staticClass:"fee-text"},[_vm._v(_vm._s(_vm.title)+"："+_vm._s(_vm.feeText)+" 万元")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }